import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Home from './components/Home';
import PdfFromImages from './components/PdfFromImages';
import MergePdfs from './components/MergePdfs';
import CompressPdf from './components/CompressPdf';
import RemovePagesPdf from './components/RemovePagesPdf';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/pdf-tools" element={<Home />} />
        <Route path="/pdf-tools/convert-images-to-PDF" element={<PdfFromImages />} />
        <Route path="/pdf-tools/merge-pdfs" element={<MergePdfs />} />
        <Route path="/pdf-tools/compress-pdf" element={<CompressPdf />} />
        <Route path="/pdf-tools/remove-pages-from-pdf" element={<RemovePagesPdf />} />

        <Route 
          path="/pdf-from-images" 
          element={<Navigate to="/pdf-tools/convert-images-to-PDF" replace />} 
        />

        <Route 
          path="/remove-pages" 
          element={<Navigate to="/pdf-tools/remove-pages-from-pdf" replace />} 
        />

      </Routes>
    </Router>
  );
}

export default App;
